export function formatearMontoPesos(monto) {
  // Convertir el monto a string y eliminar los caracteres no numéricos
  monto = parseFloat(monto.replace(/[^0-9.]/g, ""));

  // Verificar si el monto es válido
  if (isNaN(monto)) {
    return "";
  }

  // Redondear el monto a 2 decimales
  monto = monto.toFixed(2);

  // Separar la parte entera de la parte decimal
  let partes = monto.split(".");
  let parteEntera = partes[0];
  let parteDecimal = partes[1];

  // Agregar separador de miles a la parte entera
  parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Concatenar la parte entera y la parte decimal formateadas
  let montoFormateado = "RD$" + parteEntera + "." + parteDecimal;

  return montoFormateado;
}

export function cleanCurrency(number) {
  if (!number) {
    return number
  }
  return `${number}`.replace(/[^0-9.,RD$]/g, "");
}

export function dotsAndNumbers(number) {
  if (!number) {
    return number
  }
  return `${number}`.replace(/[^0-9.]/g, "");
}
